// extracted by mini-css-extract-plugin
export var container = "social-links-module--container--18a5b";
export var socialIcon = "social-links-module--socialIcon--4abfd";